<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="AccountsDailyFlow"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <VueSlickgrid
    name="accountsDailyFlow"
    :headerTitle="'Daily Flow'|pgettext('AccountsDailyFlowView')"
    :items="getItems"
    checkbox-row-selection
    export-to-csv
    :exportToCsvFilename="'accounts-daily-flow'|pgettext('ExportFilename')"
    footer-totals
    no-column-reorder
    :columnDefaults="b_2248226175642056_columnDefaults"
    :columns="b_2248226175642056_columns"
    class="page--grid"
    ref="grid"
    v-if="loaded"
    @selectedRowsChanged="evh_2248226175642056_selectedRowsChanged($event, {})"
    @command="evh_2248226175642056_command($event, {})"
  >
    <DIV
      class="flex-grow-1 d-flex"
      slot="toolbar"
    >
      <UcAccountSelector
        v-model="parameters.account"
        class="mr-2"
      >
      </UcAccountSelector>
      <DateRangeSelector
        name="paymentFilters"
        :from="parameters.date_from"
        :to="parameters.date_to"
        class="mr-2"
        @changed="evh_8320016629450276_changed($event, {})"
      >
      </DateRangeSelector>
      <BtnLoad
        :action="actions.load"
        class="mr-2"
        @click="evh_6705964765214521_click($event, {})"
      >
      </BtnLoad>
      <PageHelp
        path="/finance/accounts-daily-flow.html"
      >
      </PageHelp>
    </DIV>
  </VueSlickgrid>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "accountsDailyFlow",
    path: "/accounts-daily-flow",
    component: "AccountsDailyFlow"
  }
)

@Component()
export default class AccountsDailyFlow extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
    this.$$cache_parameters = new ComponentValueCache(this, "parameters", "AccountsDailyFlowViewFilters");
  }

  getItems(...args: any[]) {
    const parameters = this.parameters;
    return this.$fn.fetch('browse_accounts_daily_flow', {
      parameters: {
        ...parameters,
        account: parameters.account.id
      }
    })
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  selectedItems!: any;
  accounts!: any;

  async $$load_accounts() {
    return this.$fn.fetch('list_account')
      .then(resp => _.orderBy(resp.data, ['inactive', 'account_type', 'name'], ['asc', 'desc', 'asc']))
  }

  parameters!: any;

  async $$load_parameters() {
    return {
      date_from: null,
      date_to: null,
      account: this.accounts ? this.accounts[0] : null,
    }
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_2248226175642056_columnDefaults!: any;
  b_2248226175642056_columns!: any;
  dataMembers = ['selectedItems', 'accounts', 'parameters', 'ux', 'b_7315092382398562_modalBindings', 'b_2248226175642056_columnDefaults', 'b_2248226175642056_columns'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        selectedItems: [
        ]
        ,
        accounts: null,
        parameters: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
        b_2248226175642056_columnDefaults: {
          filterable: true,
          resizable: true,
        }
        ,
        b_2248226175642056_columns: [{
          field: "date",
          name: this.$fn.pgettext("AccountsDailyFlowView", "Date"),
        }
          ,
        {
          field: "open",
          name: this.$fn.pgettext("AccountsDailyFlowView", "Opening balance"),
          type: "number",
          noFooterTotals: true,
          formatter: "number",
        }
          ,
        {
          field: "pay_in",
          name: this.$fn.pgettext("AccountsDailyFlowView", "Pay in"),
          type: "number",
          formatter: "number",
        }
          ,
        {
          field: "pay_out",
          name: this.$fn.pgettext("AccountsDailyFlowView", "Pay out"),
          type: "number",
          formatter: "number",
        }
          ,
        {
          field: "close",
          name: this.$fn.pgettext("AccountsDailyFlowView", "Closing balance"),
          type: "number",
          noFooterTotals: true,
          formatter: "number",
        }
          ,
        ]
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.pgettext("AccountsDailyFlowView", "Daily Flow"),
        icon: this.$config.accountsDailyFlow.icon,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_7814_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_7814, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_setData_7816_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_2248226175642056_setData_7816, alias=undefined
    return {
      path: "selectedItems",
      value: this.$refs.grid.getSelectedItems(),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_2248226175642056_selectedRowsChanged(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_selectedRowsChanged.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_showModal_7818_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_2248226175642056_showModal_7818, alias=undefined
    return {
      name: "Account",
      props: {
        oid: $event.data.data.account_id,
      }
      ,
    }
  }

  async evh_2248226175642056_command_7817_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_2248226175642056_command_7817, alias=undefined
    return $event.data.column.id === 'account_name'
  }

  async evh_2248226175642056_command(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_command.executeFromDOM(this, event, scope);
  }

  async act_8320016629450276_setData_7820_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_8320016629450276_setData_7820, alias=undefined
    return {
      path: "parameters.date_from",
      value: $event.data[0],
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async act_8320016629450276_setData_7822_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_8320016629450276_setData_7822, alias=undefined
    return {
      path: "parameters.date_to",
      value: $event.data[1],
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_8320016629450276_changed(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8320016629450276_changed.executeFromDOM(this, event, scope);
  }

  async act_6705964765214521_reloadSlickgrid_7824_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_6705964765214521_reloadSlickgrid_7824, alias=load
    return {
      grid: "accountsDailyFlow",
    }
  }

  async evh_6705964765214521_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6705964765214521_click.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_7814: actions.CloseModalAction;
    evh_7315092382398562_close_7813: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_setData_7816: actions.SetDataAction;
    evh_2248226175642056_selectedRowsChanged_7815: actions.EventHandlerImpl;
    evh_2248226175642056_selectedRowsChanged: actions.EventHandlerGroup;
    act_2248226175642056_showModal_7818: actions.ShowModalAction;
    evh_2248226175642056_command_7817: actions.EventHandlerImpl;
    evh_2248226175642056_command: actions.EventHandlerGroup;
    act_8320016629450276_setData_7820: actions.SetDataAction;
    evh_8320016629450276_changed_7819: actions.EventHandlerImpl;
    act_8320016629450276_setData_7822: actions.SetDataAction;
    evh_8320016629450276_changed_7821: actions.EventHandlerImpl;
    evh_8320016629450276_changed: actions.EventHandlerGroup;
    act_6705964765214521_reloadSlickgrid_7824: actions.ReloadSlickgridAction;
    evh_6705964765214521_click_7823: actions.EventHandlerImpl;
    evh_6705964765214521_click: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_7814 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_7814_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_7813 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_7814,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_7813],
      }
    );
    const act_2248226175642056_setData_7816 = new actions.SetDataAction(
      {
        actionArgs: this.act_2248226175642056_setData_7816_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_selectedRowsChanged_7815 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_setData_7816,
        event: "selectedRowsChanged",
        displayName: "setData",
      }
    );
    const evh_2248226175642056_selectedRowsChanged = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_selectedRowsChanged_7815],
      }
    );
    const act_2248226175642056_showModal_7818 = new actions.ShowModalAction(
      {
        actionArgs: this.act_2248226175642056_showModal_7818_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_command_7817 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_showModal_7818,
        event: "command",
        when: this.evh_2248226175642056_command_7817_getWhen,
        displayName: "showModal",
      }
    );
    const evh_2248226175642056_command = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_command_7817],
      }
    );
    const act_8320016629450276_setData_7820 = new actions.SetDataAction(
      {
        actionArgs: this.act_8320016629450276_setData_7820_getActionArgs,
        events: [],
      }
    );
    const evh_8320016629450276_changed_7819 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_setData_7820,
        event: "changed",
        displayName: "setData",
      }
    );
    const act_8320016629450276_setData_7822 = new actions.SetDataAction(
      {
        actionArgs: this.act_8320016629450276_setData_7822_getActionArgs,
        events: [],
      }
    );
    const evh_8320016629450276_changed_7821 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_setData_7822,
        event: "changed",
        displayName: "setData",
      }
    );
    const evh_8320016629450276_changed = new actions.EventHandlerGroup(
      {
        handlers: [evh_8320016629450276_changed_7819, evh_8320016629450276_changed_7821],
      }
    );
    const act_6705964765214521_reloadSlickgrid_7824 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_6705964765214521_reloadSlickgrid_7824_getActionArgs,
        displayName: "load",
        events: [],
      }
    );
    const evh_6705964765214521_click_7823 = new actions.EventHandlerImpl(
      {
        action: act_6705964765214521_reloadSlickgrid_7824,
        event: "click",
        displayName: "load",
      }
    );
    const evh_6705964765214521_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_6705964765214521_click_7823],
      }
    );
    return {
      act_7315092382398562_closeModal_7814,
      evh_7315092382398562_close_7813,
      evh_7315092382398562_close,
      act_2248226175642056_setData_7816,
      evh_2248226175642056_selectedRowsChanged_7815,
      evh_2248226175642056_selectedRowsChanged,
      act_2248226175642056_showModal_7818,
      evh_2248226175642056_command_7817,
      evh_2248226175642056_command,
      act_8320016629450276_setData_7820,
      evh_8320016629450276_changed_7819,
      act_8320016629450276_setData_7822,
      evh_8320016629450276_changed_7821,
      evh_8320016629450276_changed,
      act_6705964765214521_reloadSlickgrid_7824,
      evh_6705964765214521_click_7823,
      evh_6705964765214521_click,
      load: act_6705964765214521_reloadSlickgrid_7824,
    }
  }
}

Vue.component("AccountsDailyFlow", AccountsDailyFlow);

</script>